import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfFuelType } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

const initialValuesOfFuelType = {
	ID: '',
	DESCRICAO: '',
	ORGAO: '',
};

export const useListFuelTypesController = () => {
	const [fuelTypesData, setFuelTypesData] = useState<ModelOfFuelType[]>([]);
	const [selectedFuelType, setSelectedFuelType] = useState<ModelOfFuelType>(initialValuesOfFuelType);
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getFuelTypes = () => {
		api.get(`fuels/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setFuelTypesData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeFuelType = (fueltype: ModelOfFuelType) => {
		setLoading(true);
		api.delete(`fuels/${fueltype.ID}`)
			.then(() => {
				getFuelTypes();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O tipo de combustível foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getFuelTypes();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editFuelType = (fueltype: ModelOfFuelType) => {
		setLoading(true);

		const editedFuelType: ModelOfFuelType = {
			...fueltype,
			ORGAO: userAgencyId,
		};

		api.put(`fuels/${selectedFuelType?.ID}`, editedFuelType)
			.then(() => {
				getFuelTypes();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O tipo de combustível foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getFuelTypes();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getFuelTypes();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userAgencyId]);

	const openDeleteDialog = (fueltype: ModelOfFuelType) => {
		setDeleteDialog(true);
		setSelectedFuelType(fueltype);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (fueltype: ModelOfFuelType) => {
		setEditDialog(true);
		setSelectedFuelType(fueltype);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfFuelType>({
		initialValues: {
			ORGAO: selectedFuelType.ORGAO,
			DESCRICAO: selectedFuelType.DESCRICAO,
		},
		onSubmit: async values => await editFuelType(values),
		validationSchema,
	});

	return {
		getFuelListController: {
			formik,
			fuelTypesData,
			selectedFuelType,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleFuelListController: {
			removeFuelType,
			editFuelType,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
		},
	};
};
